import React, { useEffect, useState } from "react";

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    fetch("/api/get-testimonials.php")
      .then((res) => {
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
        return res.json();
      })
      .then((data) => {
        console.log("Testimonials data:", data);
        setTestimonials(data);
      })
      .catch((err) => {
        console.error("Testimonials fetch error:", err);
      });
  }, []);

  if (testimonials.length === 0) return null;

  return (
    <section id="testimonials">
      <h2>What Our Clients Say</h2>

      <div className="services-grid">
        {testimonials.map((t, i) => (
          <div className="service-card" key={i}>
            <p style={{ fontStyle: "italic" }}>
              “{t.message}”
            </p>
            <h3>{t.name}</h3>
            {t.company && <small>{t.company}</small>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
